import NoPage from "./NoPageFound";
import React from "react";

const SignUp = React.lazy(() => import("./SignUp/SignUp"));
const ForgottonPassword = React.lazy(() =>
  import("./ForgottonPassword/index.jsx")
);
const SetNewPassword = React.lazy(() =>
  import("./ForgottonPassword/SetNewpassword.jsx")
);
const Home = React.lazy(() => import("./Home/index"));
const Profile = React.lazy(() => import("./Profile/index"));
const CompleteProfile = React.lazy(() =>
  import("./CompleteProfile/CompleteProfile")
);
const HomePage = React.lazy(() => import("./HomePage"));
const HomeLandingPage = React.lazy(() => import("./HomePage/HomeLandingPage"));
const AppLayout = React.lazy(() =>
  import("../assets/genericComponents/AppLayout/index")
);
const Login = React.lazy(() => import("./Login"));
const Dashboard = React.lazy(() => import("./Dashboard"));
const Scheduler = React.lazy(() => import("./TeamScheduler"));
const Income = React.lazy(() => import("./Income"));
const Expense = React.lazy(() => import("./Expenses"));
const InvoiceList = React.lazy(() => import("./InvoiceList"));
const NewInvoice = React.lazy(() => import("./NewInvoice"));
const Salary = React.lazy(() => import("./Salary"));
const AddSalary = React.lazy(() => import("./AddSalary"));
const FinanceDashboard = React.lazy(() => import("./FinanceDashboard"));
const ProvidentFund = React.lazy(() => import("./ProvidentFund"));
const Loans = React.lazy(() => import("./Loans"));
const Employee = React.lazy(() => import("./Employee"));
const CashCategory = React.lazy(() => import("./CashCategory"));
const Assets = React.lazy(() => import("./Assets"));
const AssetAllocation = React.lazy(() => import("./AssetAllocation"));
const AddEmployee = React.lazy(() => import("./AddEmployee"));
const Clients = React.lazy(() => import("./Clients"));
const DailyAttendance = React.lazy(() => import("./DailyAttendance"));
const Attendance = React.lazy(() => import("./Attendance"));
const LeaveRequest = React.lazy(() => import("./LeaveRequest"));
const LateComing = React.lazy(() => import("./LateComing"));
const UserList = React.lazy(() => import("./UserList"));
const Departments = React.lazy(() => import("./Departments"));
const Teams = React.lazy(() => import("./Teams"));
const Suggestions = React.lazy(() => import("./Suggestions"));
const Holidays = React.lazy(() => import("./Holidays"));
const UserRoles = React.lazy(() => import("./UserRoles"));
const Trash = React.lazy(() => import("./Trash"));
const Files = React.lazy(() => import("./Files/index.jsx"));
const Projects = React.lazy(() => import("./Projects/index"));
const AddNewProject = React.lazy(() => import("./Projects/AddNewProject.jsx"));
const ProjectMileStone = React.lazy(() =>
  import("./Projects/ProjectMileStone.jsx")
);
const ProjectSetting = React.lazy(() => import("./Projects/ProjectSetting"));
const WorkLoad = React.lazy(() => import("./WorkLoad/index.jsx"));
const ManageMenu = React.lazy(() => import("./ManageMenu/index.jsx"));
const VideoLink = React.lazy(() => import("./VideoLinks/index.jsx"));
const VideoCall = React.lazy(() => import("./VideoCall/index.jsx"));
const Event = React.lazy(() => import("./Event"));
const NewWorkLoad = React.lazy(() => import("./NewWorkLoad/index"));
const KanBan = React.lazy(() => import("./ProjectTasks(Kanban)"));
const FileCategory = React.lazy(() => import("./FileCategory"));
const ManageUser = React.lazy(() => import("./NewUser"));
const Organization = React.lazy(() => import("./Organization"));
const ToDo = React.lazy(() => import("./ToDo"));
const ProjectSettings = React.lazy(() => import("./ProjectSettings"));
const BillableHours = React.lazy(() => import("./BillableHours"));
const RoleBasedMenus = React.lazy(() => import("./RoleBasedMenus"));
const MyWork = React.lazy(() => import("./MyWork"));
const ReportFiles = React.lazy(() => import("./ReportFiles"));
const NotificationSettings = React.lazy(() => import("./NotificationSettings"));
const NoticeBoard = React.lazy(() => import("./NoticeBoard"));
const Templates = React.lazy(() => import("./Feedbacks/Templates"));
const FeedbackAssign = React.lazy(() => import("./Feedbacks/FeedbackAssign"));
const BdProjectData = React.lazy(() => import("./BdProjectData"));
const BdProjectAgentAllocation = React.lazy(() =>
  import("./BdProjectAgentAllocation")
);
const ProjectWithTemplate = React.lazy(() =>
  import("./Projects/ProjectWithTemplate")
);
const Pricing = React.lazy(() => import("./Pricing/index.jsx"));
const ProjectTemplate = React.lazy(() => import("./Projects/ProjectTemplate"));
const UsersSummary = React.lazy(() => import("./Reports/UsersSummary/index.jsx"));
const ProjectsSummary = React.lazy(() => import("./Reports/ProjectsSummary/index.jsx"));

const WEB_PAGES = {
  HOMEPAGE: HomePage,
  HOMELANDINGPAGE: HomeLandingPage,
  LOGIN: Login,
  VIDEOCALL: VideoCall,
  SIGN_UP: SignUp,
  FORGOTTONPASSWORD: ForgottonPassword,
  SETNEWPASSWORD: SetNewPassword,
  HOME: Home,
  COMPLETEPROFILE: CompleteProfile,
  DASHBOARD: Dashboard,
  TEAMSCHDULER: Scheduler,
  INCOME: Income,
  EXPENSE: Expense,
  INVOICELIST: InvoiceList,
  NEWINVOICE: NewInvoice,
  SALARY: Salary,
  ADDSALARY: AddSalary,
  FINANCE_DASHBOARD: FinanceDashboard,
  NOPAGE: NoPage,
  PROVIDENTFUND: ProvidentFund,
  LOANS: Loans,
  EMPLOYEE: Employee,
  CASHCATEGORY: CashCategory,
  ASSETS: Assets,
  ASSETSALLOCATION: AssetAllocation,
  ADDEMPLOYEE: AddEmployee,
  CLIENTS: Clients,
  DAILYATTENDANCE: DailyAttendance,
  ATTENDANCE: Attendance,
  LEAVEREQUEST: LeaveRequest,
  LATECOMING: LateComing,
  USERLIST: UserList,
  DEPARTMENTS: Departments,
  TEAMS: Teams,
  SUGGESTIONS: Suggestions,
  HOLIDAYS: Holidays,
  USER_ROLES: UserRoles,
  TRASH: Trash,
  FILES: Files,
  PROJECTS: Projects,
  ADDNEWPROJECT: AddNewProject,
  PROJECTMILESTORE: ProjectMileStone,
  PROJECTSETTING: ProjectSetting,
  WORKLOAD: WorkLoad,
  MANAGEMENU: ManageMenu,
  VIDEOLINKS: VideoLink,
  EVENT: Event,
  FILE_CATEGORY: FileCategory,
  KANBAN: KanBan,
  MANAGEUSER: ManageUser,
  ORGANIZATION: Organization,
  PROJECTWITHTEMPLATE: ProjectWithTemplate,
  TODO: ToDo,
  PROJECTSETTINGS: ProjectSettings,
  BILLABLEHOURS: BillableHours,
  ROLEBASEDMENUS: RoleBasedMenus,
  MYWORK: MyWork,
  REPORTFILES: ReportFiles,
  NOTIFICATIONSETTINGS: NotificationSettings,
  NOTICEBOARD: NoticeBoard,
  TEMPLATE: Templates,
  FEEDBACKASSIGN: FeedbackAssign,
  BDPROJECTDATA: BdProjectData,
  BDPROJECTAGENTALLOCATION: BdProjectAgentAllocation,
  PRICING: Pricing,
  UPDATED_LAYOUT: AppLayout,
  NEW_WORK_LOAD: NewWorkLoad,
  PROJECT_TEMPLATE: ProjectTemplate,
  PROFILE: Profile,
  USERS_SUMMARY: UsersSummary,
  PROJECTS_SUMMARY: ProjectsSummary,
};

export { WEB_PAGES };
